var map = {
	"./Module/admin/admin.module": [
		"./src/app/Module/admin/admin.module.ts",
		"common",
		"Module-admin-admin-module"
	],
	"./Module/master-data/master-data.module": [
		"./src/app/Module/master-data/master-data.module.ts",
		"default~Module-master-data-master-data-module~Module-report-report-module~Module-sale-sale-module",
		"default~Module-master-data-master-data-module~Module-sale-sale-module",
		"Module-master-data-master-data-module"
	],
	"./Module/report/report.module": [
		"./src/app/Module/report/report.module.ts",
		"default~Module-master-data-master-data-module~Module-report-report-module~Module-sale-sale-module",
		"Module-report-report-module"
	],
	"./Module/sale/sale.module": [
		"./src/app/Module/sale/sale.module.ts",
		"default~Module-master-data-master-data-module~Module-report-report-module~Module-sale-sale-module",
		"default~Module-master-data-master-data-module~Module-sale-sale-module",
		"common",
		"Module-sale-sale-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;